import React, { useState, useEffect } from 'react';
import Checkbox from './Checkbox/Checkbox';

export type CustomerAcceptanceProps = {
  customerAcceptanceText: string[];
  setAgreedCustomerAcceptance: (agreedCustomerAcceptance: boolean) => void;
  customerAcceptanceTickboxText: string;
};

export const CustomerAcceptance = ({
  customerAcceptanceText,
  setAgreedCustomerAcceptance,
  customerAcceptanceTickboxText
}: CustomerAcceptanceProps): JSX.Element => {
  const [agreed, setAgreed] = useState(false);

  useEffect(() => {
    setAgreedCustomerAcceptance(agreed);
  }, [agreed]);

  const renderParagraph = (section: string, id: number) => {
    return (
      <p
        id={`acceptance-text-${id}`}
        key={`acceptance-text-${id}`}
        className='m1-bottom'>
        {section}
      </p>
    );
  };

  const onChange = () => {
    setAgreed(!agreed);
  };

  return (
    <div>
      <>{customerAcceptanceText.map((text, i) => renderParagraph(text, i))}</>
      <Checkbox
        id='acceptance-text-checkbox'
        checked={agreed}
        text={customerAcceptanceTickboxText}
        onChange={onChange}
      />
    </div>
  );
};

export default CustomerAcceptance;
